<template>
<div>
    <ul class="list-group discussions">{{comment}}
        <li :id="'comment' + comment.id" v-bind:class="{'moderated': comment.moderated==true}" class="discussion clearfix">
            <div class="panel clearfix" v-if="comment.moderated!==true">

                <div class="col-xs-12">
                    <div class="col-xs-3">
                        <img v-bind:src="comment.user.avatar">
                        <div class="author">posted <span v-if="comment.user.firstName">by {{comment.user.firstName}} {{comment.user.lastName}}</span> {{comment.createdAt | timeSince}} ago</div>
                    </div>

                    <div class="col-xs-9">
                        <div class="content" v-html="comment.text"></div>
                        <button class="btn btn-success" v-if="reply.form===false" @click.prevent="reply.form = !reply.form">Reply</button>
                        <button class="btn btn-danger" @click.prevent="deleteComment" v-show="role=='Faculty'">Delete</button>
                    </div>
                </div>

                <form class="col-xs-12" v-if="reply.form===true" @submit.prevent="postReply(comment.id)">
                    <div class="form-group">
                        <textarea  class="form-control" v-model="reply.body"></textarea>
                    </div>
                    <div class="form-group">
                        <input type="submit" class="btn btn-success" value="Submit">
                    </div>
                </form>
            </div>
            <div class="panel clearfix instructor-moderated" v-else v-if="comment.moderated==true">
                <div class="col-xs-12">
                    <div class="col-xs-3">
                        <img v-if="role=='Faculty'" v-bind:src="comment.user.avatar">
                        <div v-if="role=='Faculty'" class="author">Posted by {{comment.user.firstName}} {{comment.user.lastName}} {{comment.createdAt | timeSince}} ago</div>
                    </div>

                    <div class="col-xs-9">
                        <div v-if="role=='Faculty'" class="content" v-html="comment.text"></div>
                        <div v-else><h3>This post has been moderated</h3></div>
                    </div>
                </div>

                <form class="col-xs-12" v-if="reply.form===true" @submit.prevent="postReply(comment.id)">
                    <div class="form-group">
                        <textarea v-model="reply.body"></textarea>
  
<!--                         <vue-html5-editor @change="updateContent" :content="content" :height="300"></vue-html5-editor>
 -->                    </div>
                    <div class="form-group">
                        <input type="submit" class="btn btn-success" value="Submit">
                    </div>
                </form>
            </div>
            {{comment.descendents}}
            <video-comment v-if="comment.descendents" v-for="childComment in comment.descendents" :post="childComment" :recordingId="recordingId"></video-comment>
        </li>

    </ul>
    </div>
</template>

<script>
    import meetings from '../../../services/meetings';
    import toastr from 'toastr';
    import VueScrollTo from 'vue-scrollto';

    export default {
        props: ['comment', 'recordingId'],
        template: '#comment',
        name: 'video-comment',
        data() {
            return {            
                reply: {
                    form:false,
                    body: ''
                }
            };
        },
        mounted() {          
          if (this.$route.params.postId && this.$route.params.postId == this.comment.id) {
              VueScrollTo.scrollTo('#comment' + this.comment.id, 0);
          }          
        },
        methods: {

          deleteComment() {
            var self = this;
            discussions.delete(this, this.comment.id).then(function() {
                self.$bus.$emit('commentAdded');
            });
            
        },
        postReply(parent) {
            var self = this;
            if (!self.reply.body) {
                toastr.error('Please enter a comment');
                return;
            }
            
            var comment = {
                parent: parent,
                userId: localStorage.account_id,
                recordingId: self.recordingId,
                text: this.reply.body
            }   
            meetings.addComment(self, comment).then(function(response) {
                self.$bus.$emit('commentAdded');
            });
        },
    },
    computed: {
      role() {
        return localStorage.getItem('role');
    },
}
}
</script>

<style lang="scss" scoped>
  .content {
    background: lighten(#303030, 10%);
    padding:1rem;

}
.author {
    font-style:italic;
    padding-bottom:2rem;
}
button {
    float:right;
    margin-top:2rem;
}
.discussions {
    background:#303030;
}
.discussion {
    list-style-type:none;
    margin:0;
    padding-left:2rem;
    border: 1px solid #464545;
    border-radius:2px;
    .panel {
        padding:1rem;
        padding-top:2rem;
        margin-bottom: 0;
        padding-bottom:0;
    }
}

.instructor-moderated {
    background:#b62516;
    h3 {
        margin-bottom:4rem;
    }
}
</style>

<style lang="scss">
  .content img {
    max-width: 100%;
}
</style>


// WEBPACK FOOTER //
// VideoComment.vue?1a2b729f